export default __webpack_public_path__ + "static/applet-03-set-1-dc02c4df3c16f2fac4a9e1b3ac9a80a0.webp";